import { File05 } from "@untitledui/icons";
import { TextArea } from "@/components/base/textarea/textarea";
import { FieldGroup } from "./FieldGroup";
import type { CustomRiskRequestForm } from "./RequestCustomRiskModal";

type Props = {
  form: CustomRiskRequestForm;
  onChange: (patch: Partial<CustomRiskRequestForm>) => void;
  errors: Record<string, string>;
};

export function ExamplesStep({ form, onChange, errors }: Props) {
  return (
    <div className="flex gap-8">
      <div className="w-48 shrink-0 flex flex-col gap-3">
        <div className="bg-indigo-50 rounded-lg p-2 w-fit">
          <File05 className="size-5 text-indigo-700" />
        </div>
        <div className="flex flex-col gap-2">
          <p className="text-sm font-semibold text-primary">Examples</p>
          <p className="text-sm text-tertiary">
            Give us a few concrete examples to anchor the detection. Counter-examples help us avoid false positives.
          </p>
        </div>
      </div>

      <div className="flex flex-1 flex-col gap-5">
        <FieldGroup
          label="Examples that should trigger this risk"
          description="3 to 5 concrete examples. Phrases, scenarios, or links to existing creator videos."
          required
          error={errors["examples.positive"]}
        >
          <TextArea
            aria-label="Examples that should trigger this risk"
            isRequired
            placeholder={"1. ...\n2. ...\n3. ..."}
            value={form.examples.positive}
            onChange={(v) => onChange({ examples: { ...form.examples, positive: v } })}
            isInvalid={!!errors["examples.positive"]}
            rows={5}
          />
        </FieldGroup>

        <FieldGroup label="Examples that should NOT trigger it" description="1 to 2 counter-examples.">
          <TextArea
            aria-label="Examples that should NOT trigger it"
            placeholder={"1. ...\n2. ..."}
            value={form.examples.counter ?? ""}
            onChange={(v) => onChange({ examples: { ...form.examples, counter: v || undefined } })}
            rows={4}
          />
        </FieldGroup>
      </div>
    </div>
  );
}
